import React, { useState } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import { checkPermission } from '../../../../utils_v2';
import LatePaymentCRU from './LatePaymentCRU';
import { AttachmentsRow } from '../../components';

export default function LatePaymentList({item, previewDetail, getResponseBack, contractInfo,deletecontibution}){
  const [showMore, setShowMore] = useState({});
  const toggleDescription = (id) => {
    setShowMore({
      ...showMore,
      [id]: !showMore[id],
    });
  };
  return(
    <>
    <TableRow hover >
      <TableCell>{item?.name}</TableCell>
      <TableCell>{item?.interest_index ? item?.interest_index : '--'}</TableCell>
      <TableCell>{item?.margin ? item?.margin : '--'}</TableCell>
      <TableCell style={{maxWidth:'400px'}}>
      {item?.description && item?.description?.length > 200 ? (
          <div style={{ maxWidth: '400px' }}>
            {showMore[item?.id] && showMore[item?.id] ? (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id); }} >
                  less
                </a>
              </span>
            ) : (
              <span>
                <span dangerouslySetInnerHTML={{ __html: item?.description.substring(0, 190).replace(/\n/g, '<br />') }} />
                <a href='#' style={{ color: '#0E7FE1', fontSize: '14px' }} onClick={(e) => { e.preventDefault(); toggleDescription(item?.id); }} >
                  ..more
                </a>
              </span>
            )}
          </div>
        ) : (
          <div>
               {item?.description? <span dangerouslySetInnerHTML={{ __html: item?.description.replace(/\n/g, '<br />') }} />:'--'}
          </div>
        )}
        </TableCell>
        <TableCell>{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell>  
      <TableCell>
        <LatePaymentCRU getResponseBack={getResponseBack} m="V" id={item?.id} contractInfo={contractInfo}/>
        {checkPermission('contracts','late_payment_interest', 'D')?<DeleteIcon fontSize='small' color='secondary' style= {{cursor:'pointer'}} onClick={()=>deletecontibution(item?.id)}/>:null}
      </TableCell>
      </TableRow>
    </>
  )
}
